import {
  EditButton,
  ListButton,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

import { RolesTableField } from "@/fields/RolesTableField";

const ShowActions = () => (
  <TopToolbar>
    <ListButton />
    <EditButton />
  </TopToolbar>
);

export const GroupShow = () => (
  <Show actions={<ShowActions />}>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="description" />
      <RolesTableField source="roles" label="Methods list" />
    </SimpleShowLayout>
  </Show>
);
